import { useState } from "react";
import "./Contact.css";

function Contact() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      //const response = await fetch("http://localhost:5001/api/send-email", {
     const response = await fetch("https://the-heritage-house.com/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: "New Contact Form Inquiry",
          to: "eric.korslin@the-heritage-house.com",
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email,
          phone: form.phone,
          message: form.message,
        }),
      });

      if (!response.ok) {
        console.error(await response.text());
        alert("Failed to send message");
        return;
      }

      alert("Message sent successfully!");
      setForm({ firstName: "", lastName: "", email: "", phone: "", message: "" });
    } catch (err) {
      console.error(err);
      alert("Failed to send message");
    }
  };


  // const sendEmail = async (e) => {
  //   e.preventDefault();
  //   //const response = await fetch("http://localhost:5001/api/send-email", {
  //   const response = await fetch("https://the-heritage-house.com/api/send-email", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       to: "eric.korslin@the-heritage-house.com",
  //       subject: "New Contact Form Inquiry",
  //       firstName: form.firstName,
  //       lastName: form.lastName,
  //       email: form.email,
  //       phone: form.phone,
  //       message: form.message,
  //     }),
  //   });

//     const data =  response.json();

//     if (!response.ok) {
//       alert("Failed to send message");
//       console.error(data);
//       return;
//     }

//     alert("Message sent successfully!");

//     // Clear form
//     setForm({
//       firstName: "",
//       lastName: "",
//       email: "",
//       phone: "",
//       message: "",
//     });
//   };
// };
  return (
    <div className="contact-us-div">
      <form className="contact-us-form" onSubmit={sendEmail}>
        <h3 className="contact-us-title">Contact Us</h3>
        <br />
        <text className="blurb">Please reach out with any questions, special requests or concerns.<br/>We are more than happy to assist and ensure a wonderful experience.</text><br/><br/><br/>

        <label>First Name</label><br />
        <input
          type="text"
          name="firstName"
          value={form.firstName}
          onChange={handleChange}
          required
          style={{ border: '1px solid black' }}
        /><br /><br />

        <label>Last Name</label><br />
        <input
          type="text"
          name="lastName"
          value={form.lastName}
          onChange={handleChange}
          required
          style={{ border: '1px solid black' }}
        /><br /><br />

        <label>Email Address</label><br />
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          required
          style={{ border: '1px solid black' }}
        /><br /><br />

        <label>Phone Number</label><br />
        <input
          type="tel"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          style={{ border: '1px solid black' }}
        /><br /><br />

        <label>Questions?</label><br />
        <textarea
          name="message"
          rows="4"
          cols="42"
          value={form.message}
          onChange={handleChange}
          required
          style={{ border: '1px solid black' }}
        /><br /><br />

        <button type="submit" className="submit-contact-form">
          SUBMIT
        </button>
      </form>
    </div>
  );
}

export default Contact;
